import React from 'react';
import { AxiosError, AxiosResponse } from 'axios';
import { Autocomplete } from '@material-ui/lab';
import { Grid, Icon, IconButton, InputAdornment,TextField } from '@material-ui/core';

import { ClientContext } from '../../ClientContext';
import { HomeContext } from '../../../Home/HomeContext';
import { AuthContext } from '../../../Authentication/AuthContext';
import ClippingParametersService from '../../../../Services/ClippingParametersService';
import { clipperDataInitial, ClipperModel } from '../../../../Models/ClipperModel';
import { clientClipperModelInitial } from '../../../../Models/ClientClipperModel';
import { ClientClipperFilterModel, clientClipperFilterModelInitial } from '../../../../Models/ClientClipperFilterModel';
import { clippingParameterModelInitial, ClippingParameterModel } from '../../../../Models/ClippingParameterModel';
import { theme } from '../../../../theme';
import { EditAction } from '../../../../shared/enum/EditAction';
import { BasicConfirmDialog } from '../../../../shared/components/BasicConfirmDialog';
import { IShowDialogProps } from '../../components/ClientPages';
import { ClientClipperContext } from '../ClientClipperContext';
import { ModalClippingParameters } from './ModalClippingParameters';
import { ClippingParametersContext } from '../ClippingParametersContext';

export function ClientClipperModal({showDialog, setShowDialog}: IShowDialogProps) {
    const clientContext = React.useContext(ClientContext);
    const clientClipperContext = React.useContext(ClientClipperContext);
    const homeContext = React.useContext(HomeContext);
    const authContext = React.useContext(AuthContext);

    const [clipperNotSelectedError, setClipperNotSelectedError] = React.useState<boolean>(false);
    const [loginNotDefinedError, setLoginNotDefinedError] = React.useState<boolean>(false);
    const [passwordNotDefinedError, setPasswordNotDefinedError] = React.useState<boolean>(false);

    const [requiredClippingParameterError, setRequiredClippingParameterError] = React.useState<boolean>(false);
    const [clippingParameterNotSelectedError, setClippingParameterNotSelectedError] = React.useState<boolean>(false);
    const [clippingParameterValueNotDefinedError, setClippingParameterValueNotDefinedError] = React.useState<boolean>(false);
    const [clippingParametersEditMode, setClippingParametersEditMode] = React.useState(false);
    const [currentClippingParameterIndex, setCurrentClippingParameterIndex] = React.useState<number>(-1);
    
    const [currentClientClipperFilter, setCurrentClientClipperFilter] = React.useState<ClientClipperFilterModel>(clientClipperFilterModelInitial);
    const [currentClippingParameter, setCurrentClippingParameter] = React.useState<ClippingParameterModel | null>(null);    
    
    const [showClipperModalPassword, setShowClipperModalPassword] = React.useState<boolean>(false);

    const fetchClippingParametersList = (clipper: ClipperModel) => {
        homeContext.setOpenLoadingDialog(true);

        ClippingParametersService.clippingParametersService(clipper.id)
            .getAll()
            .then((res: AxiosResponse) => clientClipperContext.setCurrentClipper({...clipper, clippingParameters: res.data}))
            .catch((error: AxiosError) => homeContext.showError('Ops.. ocorreu um erro com os filtros de clipping automático. <br/>', error))
            .finally(() => homeContext.setOpenLoadingDialog(false));
    };

    const clearClippingParametersFields = () => {
        setCurrentClippingParameter(clippingParameterModelInitial);
        setCurrentClientClipperFilter(clientClipperFilterModelInitial);
        setCurrentClippingParameterIndex(-1);
        setClippingParametersEditMode(false);
        setClippingParameterNotSelectedError(false);
        setClippingParameterValueNotDefinedError(false);
    };

    const hasClipperError = () => {
        const errorClipperNotSelected = !clientClipperContext.currentClipper || !clientClipperContext.currentClipper.id || clientClipperContext.currentClipper.id < 1;
        const errorLoginNotDefined = !clientClipperContext.currentClientClipper.login;
        const errorPasswordNotDefined = !clientClipperContext.currentClientClipper.password;
        const errorClippingParameterNotDefined = !clientClipperContext.currentClientClipper.clippingFilters || clientClipperContext.currentClientClipper.clippingFilters.length == 0;

        setClipperNotSelectedError(errorClipperNotSelected);
        setLoginNotDefinedError(errorLoginNotDefined);
        setPasswordNotDefinedError(errorPasswordNotDefined);
        setRequiredClippingParameterError(errorClippingParameterNotDefined);

        return errorClipperNotSelected || errorLoginNotDefined || errorPasswordNotDefined || errorClippingParameterNotDefined;
    };

    const clearAndCloseClipperModal = () => {
        clientClipperContext.setCurrentClipper(clipperDataInitial);
        clientClipperContext.setCurrentClientClipper(clientClipperModelInitial);
        clientClipperContext.setCurrentClientClipperIndex(-1);
        clientClipperContext.setClipperEditMode(false);
        setClipperNotSelectedError(false);
        setLoginNotDefinedError(false);
        setPasswordNotDefinedError(false);
        setRequiredClippingParameterError(false);
        setShowDialog(false);

        clearClippingParametersFields();
    };

    const handleModalSaveButton = () => {
        if (!hasClipperError()) {
            const clientClippers = JSON.parse(JSON.stringify(clientContext.clientClippers));
            const clientClipperModal = JSON.parse(JSON.stringify(clientClipperContext.currentClientClipper));
            clientClipperModal.clientId = clientContext.client.id;
            clientClipperModal.clipper = clientClipperContext.currentClipper;
            clientClipperModal.userId = authContext.login.user.id;

            if (clientClipperContext.clipperEditMode) {
                clientClippers[clientClipperContext.currentClientClipperIndex] = clientClipperModal;

                if (clientClippers[clientClipperContext.currentClientClipperIndex].editAction != EditAction.INSERT)
                    clientClippers[clientClipperContext.currentClientClipperIndex].editAction = EditAction.UPDATE;

                clientContext.setClientClippers(clientClippers);
                clientClipperContext.setClipperEditMode(false);
            }
            else
                clientContext.setClientClippers([...clientClippers, { ...clientClipperModal, editAction: EditAction.INSERT}]);
            
            clearAndCloseClipperModal();
        }
    };


    const handleClipperChange = (selectedClipper: ClipperModel | null) => {
        if (selectedClipper)
            fetchClippingParametersList(selectedClipper);
        else
            clientClipperContext.setCurrentClipper(clipperDataInitial);

        clientClipperContext.setCurrentClientClipper(clientClipperModelInitial);
        clearClippingParametersFields();
    };


    const getModalClipper = () => {
        return (
            <Grid item xs={4}>
                <Autocomplete
                    id="clipper"
                    options={clientClipperContext.clipperList.filter(c => 
                        clientContext.clientClippers.filter(cc => 
                            cc.clipper?.id == c.id && cc.editAction != EditAction.DELETE).length == 0)}
                    value={clientClipperContext.currentClipper}
                    onChange={(_, newValue: ClipperModel | null) => handleClipperChange(newValue) }
                    getOptionLabel={(option) => option.name}
                    fullWidth
                    noOptionsText="Sem resultados"
                    loadingText="Carregando..."
                    renderInput={(params) =>
                        <TextField
                            {...params}
                            label="Clipadora"
                            variant="outlined"
                            error={clipperNotSelectedError && (!clientClipperContext.currentClipper?.id || clientClipperContext.currentClipper?.id < 1)}
                            helperText={clipperNotSelectedError && (!clientClipperContext.currentClipper?.id || clientClipperContext.currentClipper?.id < 1)
                                ? 'Campo obrigatório'
                                : ''} />
                    } />
            </Grid>
        );
    };

    const getModalClipperLogin = () => {
        return (
            <Grid item xs={4}>
                <TextField
                    id="login"
                    value={clientClipperContext.currentClientClipper.login}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => 
                        clientClipperContext.setCurrentClientClipper({ ...clientClipperContext.currentClientClipper, login: event.target.value })}
                    fullWidth
                    label="Login"
                    variant="outlined"
                    error={loginNotDefinedError && !clientClipperContext.currentClientClipper.login}
                    helperText={loginNotDefinedError && !clientClipperContext.currentClientClipper.login ? 'Campo obrigatório' : ''} />
            </Grid>
        );
    };

    const getModalClipperPassword = () => {
        return (
            <Grid item xs={4}>
                <TextField
                    id="password"
                    value={clientClipperContext.currentClientClipper.password}
                    label='Senha'
                    variant="outlined"
                    fullWidth
                    type={showClipperModalPassword ? 'text' : 'password'}
                    onCut={(e: React.ClipboardEvent<HTMLDivElement>) => e.preventDefault()}
                    onCopy={(e: React.ClipboardEvent<HTMLDivElement>) => e.preventDefault()}
                    onPaste={(e: React.ClipboardEvent<HTMLDivElement>) => e.preventDefault()}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => 
                        clientClipperContext.setCurrentClientClipper({ ...clientClipperContext.currentClientClipper, password: event.target.value })}
                    error={passwordNotDefinedError && !clientClipperContext.currentClientClipper.password}
                    helperText={passwordNotDefinedError && !clientClipperContext.currentClientClipper.password ? 'Campo obrigatório' : ''}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton
                                    aria-label="Pressione para exibir a senha"
                                    onClick={() => setShowClipperModalPassword(!showClipperModalPassword)}
                                    onMouseDown={(event) => event.preventDefault()}>
                                    {showClipperModalPassword
                                        ? <Icon>visibility</Icon>
                                        : <Icon>visibility_off</Icon>}
                                </IconButton>
                            </InputAdornment>
                        )
                    }}
                />
            </Grid>
        );
    };
    
    const getClipperModal = () => {
        return (
            <ClippingParametersContext.Provider value={{
                requiredClippingParameterError, setRequiredClippingParameterError,
                clippingParameterNotSelectedError, setClippingParameterNotSelectedError,
                clippingParameterValueNotDefinedError, setClippingParameterValueNotDefinedError,
                clippingParametersEditMode, setClippingParametersEditMode,
                currentClippingParameterIndex, setCurrentClippingParameterIndex,
                currentClientClipperFilter, setCurrentClientClipperFilter,
                currentClippingParameter, setCurrentClippingParameter
            }}>
                <Grid container spacing={3}>
                    { getModalClipper() }
                    { getModalClipperLogin() }
                    { getModalClipperPassword() }
                    <ModalClippingParameters />
                </Grid>
            </ClippingParametersContext.Provider>
        );
    };

    return (
        <BasicConfirmDialog
            title={clientClipperContext.clipperEditMode ? 'Editar clipadora' : 'Adicionar clipadora'}
            description={clientClipperContext.clipperEditMode
                ? 'Para editar uma clipadora, altere os campos que deseja e clique em salvar.'
                : 'Para adicionar uma nova clipadora, insira os dados solicitados e clique em salvar.'
            }
            textFirstButton="Descartar"
            handleFirstButton={() => clearAndCloseClipperModal()}
            textSecondButton={clientClipperContext.clipperEditMode ? 'Salvar Alterações' : 'Salvar Clipadora'}
            handleSecondButton={handleModalSaveButton}
            open={showDialog}
            children={ getClipperModal() }
            cssProperties={{ 
                minWidth: '800px',
                maxWidth: '800px',
                padding: '1rem',
                colorFirstButton: theme.palette.primary.main,
                justifyButtons: 'flex-end',
                titleVariant: 'h4',
                descriptionVariant: 'body1'
            }}
        />
    );
}